
import Form from './Form.vue'
import { useStore } from 'vuex'
import { defineComponent, ref, onMounted, computed, toRefs, reactive } from 'vue'
import swal from 'sweetalert2'

export default defineComponent({
  components: {
    Form
  },
  setup () {
    const form = reactive({
      id: '',
      sub_cluster_name: ''
    })
    const form_action = ref('save')
    const visible = ref(false)
    const store = useStore()

    const fields = ref([
      {
        title: 'SubCluster Name',
        dataIndex: 'sub_cluster_name',
      },
      // {
      //   title: "Is Active",
      //   dataIndex: "is_active",
      //   align: 'center',
      //   slots: { customRender: "is_active" }
      // },
      {
        title: 'Action',
        dataIndex: 'action',
        slots: {customRender: 'action'},
        align: 'center'
      },
    ])

    const index = (payload = {page: 1}) => {
      store.dispatch('SubCluster/index', payload)
    }

    const editRecord = (record: any) => {
      form_action.value = 'update'
      const {id, sub_cluster_name} = toRefs(form)
      id.value = record.id
      sub_cluster_name.value = record.sub_cluster_name
      visible.value = true
    }

    const createRecord = () => {
      form_action.value = 'save'
      const {id, sub_cluster_name} = toRefs(form)
      id.value = ''
      sub_cluster_name.value = ''
      visible.value = true
    }

    const deleteRecord = (record: any) => {
      store.dispatch('SubCluster/destroy', record.id)
    }

    const handleSaving = (record: any) => {
      form_action.value == 'save' ? storeRecord(record) : updateRecord(record)
    }

    const storeRecord = (payload = {}) => {
      store
          .dispatch('SubCluster/store', payload)
          .then(() => (visible.value = false))
    }

    const updateRecord = (payload = {}) => {
      store
          .dispatch('SubCluster/update', payload)
          .then(() => (visible.value = false))
    }

    const filterRecord = (payload: any) => {
      index(payload)
    }

    const items = computed(() => store.getters['SubCluster/items'])
    const loading = computed(() => store.getters['SubCluster/status'])

    onMounted(index)

    return {
      loading,
      items,
      fields,
      visible,
      form,
      editRecord,
      deleteRecord,
      storeRecord,
      createRecord,
      updateRecord,
      handleSaving,
      filterRecord
    }
  },
})
